var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59146 4.03029H9.82267C12.0941 4.03029 12.9495 5.18013 12.8173 6.87231C12.5995 9.66185 10.9129 11.2044 8.67581 11.2044H7.54644C7.23972 11.2044 7.0335 11.4069 6.95012 11.9578L6.46547 15.1557C6.43383 15.3634 6.32476 15.4855 6.16061 15.5H3.50805C3.25828 15.5 3.16969 15.309 3.23483 14.8955L4.8548 4.63703C4.91957 4.22608 5.14477 4.03029 5.59146 4.03029Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94635 0.5H7.18165C8.37467 0.5 9.78916 0.538713 10.7358 1.37327C11.3678 1.93088 11.6999 2.8194 11.6232 3.77307C11.3634 7.00706 9.42884 8.81836 6.83473 8.81836H4.74574C4.39025 8.81836 4.15463 9.05399 4.05412 9.692L3.4712 13.4002C3.43323 13.6407 3.32901 13.7825 3.13879 13.7996H0.530163C0.240563 13.7996 0.137826 13.5781 0.21339 13.0987L2.09244 1.20353C2.16763 0.727064 2.42819 0.5 2.94635 0.5Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11517 9.31827L4.8548 4.63703C4.91957 4.22608 5.14477 4.03029 5.59146 4.03029H9.82267C10.5232 4.03029 11.089 4.13973 11.5323 4.3411C11.1073 7.21923 9.2457 8.81836 6.80793 8.81836H4.71894C4.44385 8.81836 4.23838 8.95869 4.11517 9.31827Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/paypalIcon.feb5e2712c981ac754ebfaceacad768d.svg";
export { ForwardRef as ReactComponent };